export default __webpack_public_path__ + "static/IvarHeadline-Regular-26a6464dda88f8ec474d0dd000a49f32.woff2";